<template>
    <div>
        <div
            class="ask-container d-flex justify-content-between align-items-center"
        >
            <span class="ask-title" v-if="!editing">
                {{ ask.title }}
            </span>
            <Form
                :initialTitle="ask.title"
                @cancel="toggleEditing"
                @save="saveAsk"
                v-if="editing"
            />
            <div class="button-group" v-if="!editing">
                <b-button
                    variant="light"
                    size="sm"
                    @click="toggleEditing()"
                    :disabled="editing"
                >
                    <pencil />
                </b-button>
                <b-button variant="light" size="sm" @click="showConfirmAlert()">
                    <trash />
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { updateAsk, deleteAsk, createAsk } from './api'
import notification, { success, danger } from '@/lib/notification'
import { proceedWithConfirmation } from '@/lib/sweet-alert'

import { Form, Pencil, Trash } from './components'

notification.init()

export default {
    name: 'Ask',
    components: {
        Form,
        Pencil,
        Trash,
    },
    props: {
        ask: {
            type: Object,
            default: () => {
                return {
                    title: '',
                }
            },
        },
        createNewIfEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            editing: false,
        }
    },
    methods: {
        toggleEditing() {
            this.editing = !this.editing
        },
        saveAsk(newTitle) {
            this.editing = false
            if (this.createNewIfEdit) {
                return this.createAsk(newTitle)
            }
            return this.updateAsk(newTitle)
        },
        createAsk(title) {
            const newAsk = {
                title,
                template_id: null,
            }

            createAsk(newAsk).then(response => {
                this.$emit('ask-created', {
                    ...response,
                    previousId: this.ask.id,
                })

                this.$emit('update:createNewIfEdit', false)
            })
        },
        updateAsk(newTitle) {
            this.ask.title = newTitle
            updateAsk(this.ask.id, this.ask)
                .then(() => {
                    success(
                        this.$t('notification.editedSuccessfully', {
                            item: this.$t('talk.ask'),
                        })
                    )
                })
                .catch(e => {
                    console.log(e)
                    danger()
                })
        },
        showConfirmAlert() {
            if (this.createNewIfEdit) {
                this.emitDelete()
                return
            }
            return this.showProceedWithConfirmation()
        },
        showProceedWithConfirmation() {
            proceedWithConfirmation({
                onConfirm: () => deleteAsk(this.ask.id),
                callback: () => {
                    success(
                        this.$t('notification.deletedSuccessfully', {
                            item: this.$t('talk.ask'),
                        })
                    )
                    this.emitDelete()
                },
                onError: () => danger(),
            })
        },
        emitDelete() {
            this.$emit('delete-ask', this.ask.id)
        },
    },
    mounted() {
        this.form = this.ask
    },
}
</script>

<style lang="sass" scoped>
.ask-container
    padding: 10px 20px
    border: 1px solid #ececec
    border-radius: 6px
    font-size: 15px
    width: 100%
    min-height: 50px
    cursor: pointer
    .ask-title
        display: inline-block
        overflow-wrap: break-word
        max-width: 90%
.add
    font-weight: bold
.button-group
    width: auto
    .btn-light
        background-color: #ffffff
        border: 0
        &:focus
            outline: none
            border: none !important
            -webkit-box-shadow: none !important
            -moz-box-shadow: none !important
            box-shadow: none !important
    button
        margin: 0 2px 0 2px
</style>
